/**
 * Hierarchical query-key factory. Every hook that uses TanStack Query
 * imports keys from here so invalidation patterns stay consistent.
 *
 * Rule: keys are arrays, first element is the domain, then the shape
 * mirrors the URL. `queryClient.invalidateQueries({ queryKey: qk.campaigns.all })`
 * blows away every campaign-related query in one call.
 */
export const qk = {
  auth: {
    me: ['auth', 'me'] as const,
    members: ['auth', 'members'] as const,
  },
  mailboxes: {
    all: ['mailboxes'] as const,
    detail: (id: string) => ['mailboxes', id] as const,
  },
  mailboxPools: {
    all: ['mailbox-pools'] as const,
  },
  leadLists: {
    all: ['lists'] as const,
    detail: (id: string) => ['lists', id] as const,
    leads: (id: string) => ['lists', id, 'leads'] as const,
  },
  campaigns: {
    all: ['campaigns'] as const,
    detail: (id: string) => ['campaigns', id] as const,
  },
  messages: {
    list: (filters: Record<string, unknown>) => ['messages', filters] as const,
  },
  suppressions: {
    all: ['suppressions'] as const,
  },
  apiKeys: {
    all: ['api-keys'] as const,
  },
  webhooks: {
    all: ['webhooks'] as const,
    deliveries: (id: string) => ['webhooks', id, 'deliveries'] as const,
  },
  knowledgeBase: {
    all: ['knowledge-base'] as const,
  },
  analytics: {
    summary: ['analytics', 'summary'] as const,
    insights: (days: number) => ['insights', days] as const,
    replies: ['replies'] as const,
  },
  admin: {
    locations: ['admin', 'locations'] as const,
    operators: ['admin', 'operators'] as const,
  },
};
